module.exports = __webpack_public_path__ + "static/maquete_4k-96f3cc66296d2108f05412d7f8fb1861.jpg";